import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateEbDeviceProgressStepper from "./components/createEbDeviceProgressStepper"
import CoreEbDeviceDetails from "./formPages/coreEbDeviceDetails"
import EbManufacturer from "./formPages/ebManufacturer"
import ReviewAndSubmitEbDevice from "./formPages/reviewAndSubmitEbDevice"
import { CreateEbDeviceContext } from "./providers/baseProviders/createEbDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for creating an Electric Boiler device */
const CreateEbDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateEbDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateEbDeviceProgressStepper />
                </AppCardContent>
            </AppCard>
            <MultiPageForm context={CreateEbDeviceContext}>
                {canEditManufacturer && (
                    <EbManufacturer context={CreateEbDeviceContext} />
                )}
                <CoreEbDeviceDetails context={CreateEbDeviceContext} />
                <LctDeviceAttachments<HpDeviceFormData>
                    context={CreateEbDeviceContext}
                    dataset={Datasets.EB}
                    isAmendment={false}
                />
                <ReviewAndSubmitEbDevice
                    context={CreateEbDeviceContext}
                    isAmendment={false}
                />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateEbDeviceForm
